/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Firstseen1Inputs */

const he_item_stats_firstseen1 = /** @type {(inputs: Item_Stats_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נכנס למלאי לראשונה`)
};

const en_item_stats_firstseen1 = /** @type {(inputs: Item_Stats_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First seen`)
};

/**
* | output |
* | --- |
* | "First seen" |
*
* @param {Item_Stats_Firstseen1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_firstseen1 = /** @type {((inputs?: Item_Stats_Firstseen1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Firstseen1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_firstseen1(inputs)
	return en_item_stats_firstseen1(inputs)
});
export { item_stats_firstseen1 as "item_stats_firstSeen" }